import styled from 'styled-components';

export const StyledCategoryTitleContainer = styled.div`
  padding: ${({ theme }) => `${theme.space[4]}px 0 0 `};
  margin: ${({ theme }) => `0 ${theme.space[4]}px`};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
